<script lang="ts">
    import { onDestroy } from "svelte";

    import { Sorting, Creatures, SortedCreatures } from "./store";
    import { showBestiary } from "./ui.store";
    const sortingSymbols = {
        "": "↕",
        asc: "↑",
        desc: "↓",
    };
    function changeSorting(event) {
        const sortingParameter = event.target.id;

        Sorting.update((sorting) => {
            const previousValue = sorting[sortingParameter];
            Object.keys(sorting).forEach((s) => {
                sorting[s] = "";
            });
            let nextValue = "";
            switch (previousValue) {
                case "":
                    nextValue = "asc";
                    break;
                case "asc":
                    nextValue = "desc";
                    break;
                case "desc":
                    nextValue = "";
                    break;
            }
            sorting[sortingParameter] = nextValue;
            return sorting;
        });
    }

    function sortString(a, b, order) {
        let result = 0;
        if (order === "asc") {
            result = a.localeCompare(b);
        } else {
            result = b.localeCompare(a);
        }
        return result;
    }

    function sortCreatures(sorting, creatures) {
        const sortParameter = Object.keys(sorting).find(
            (key) => sorting[key] !== ""
        );
        if (!sortParameter) {
            return creatures;
        }

        const order = sorting[sortParameter];

        return [...creatures].sort((first, second) => {
            let result = 0;
            if (sortParameter === "name") {
                result = sortString(first.name, second.name, order);
            } else if (sortParameter === "difficulty") {
                if (order === "asc") {
                    result = first.difficulty < second.difficulty ? -1 : 1;
                } else {
                    result = first.difficulty > second.difficulty ? -1 : 1;
                }
            } else if (sortParameter === "book") {
                result = sortString(first.book, second.book, order);
            }

            return result;
        });
    }

    const sortUnsubscribe = Sorting.subscribe((sorting) => {
        SortedCreatures.set(sortCreatures(sorting, $Creatures));
        showBestiary();
    });

    const creaturesUnsubscribe = Creatures.subscribe((creatures) => {
        SortedCreatures.set(sortCreatures($Sorting, creatures));
        showBestiary();
    });

    onDestroy(sortUnsubscribe);
    onDestroy(creaturesUnsubscribe);
</script>

<div>
    <h2>Sort Bestiary By</h2>
    <div class="sorting-buttons">
        {#each Object.keys($Sorting) as sortParameter}
            <button
                class:active={$Sorting[sortParameter] === "asc" ||
                    $Sorting[sortParameter] === "desc"}
                on:click={changeSorting}
                id={sortParameter}
            >
                {sortParameter}
                {sortingSymbols[$Sorting[sortParameter]]}</button
            >
        {/each}
    </div>
</div>

<style>
    div {
        width: 100%;
    }
    .sorting-buttons {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    button {
        border-radius: 64px;
        padding: 8px;
        font-size: 1rem;
        width: max-content;
        margin: 4px;
    }
    button:hover {
        cursor: pointer;
        background-color: #5d0610;
    }

    button:hover:not(.active) {
        background-color: #5d0610;
    }
    button.active {
        background-color: #9c0719;
    }
</style>
